export default "__VITE_ASSET__d87444d2__"